import type { FunctionComponent, ReactNode } from "react";

import { Container, StyledBaseLink, StyledTrustLogo } from "./styles";

export type Props = {
  children?: ReactNode;
  className?: string;
};

export const ArticleTrustLabel: FunctionComponent<Props> = ({ children, className }) => (
  <Container className={className}>
    <StyledTrustLogo />

    {children ?? (
      <StyledBaseLink anchorProps={{ target: "_blank" }} pathname="/policies-and-standards">
        Why you can trust SCMP
      </StyledBaseLink>
    )}
  </Container>
);

ArticleTrustLabel.displayName = "ArticleTrustLabel";
